import React, { useState } from 'react';
import { Mail, Phone, MapPin, Instagram, Facebook, Linkedin, Send } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { useToast } from '../../hooks/use-toast';
import '../../styles/ContactSection.css';

const ContactSection = ({ data }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const { toast } = useToast();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    toast({
      title: "Message envoyé !",
      description: "Je vous répondrai dans les plus brefs délais.",
    });
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section className="contact-section section-animate">
      <div className="container">
        <h2 className="section-title">Contact</h2>
        
        <div className="contact-grid">
          <div className="contact-info">
            <h3>Restons en Contact</h3>
            <p>Que ce soit pour un projet culinaire, une collaboration ou simplement échanger sur la cuisine vegan, n'hésitez pas à me contacter !</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <Mail className="contact-icon" />
                <span>{data.email}</span>
              </div>
              
              <div className="contact-item">
                <Phone className="contact-icon" />
                <span>{data.phone}</span>
              </div>
              
              <div className="contact-item">
                <MapPin className="contact-icon" />
                <span>{data.location}</span>
              </div>
            </div>
            
            <div className="social-links">
              <a href="#" className="social-link instagram">
                <Instagram />
                <span>{data.social.instagram}</span>
              </a>
              
              <a href="#" className="social-link facebook">
                <Facebook />
                <span>{data.social.facebook}</span>
              </a>
              
              <a href="#" className="social-link linkedin">
                <Linkedin />
                <span>{data.social.linkedin}</span>
              </a>
            </div>
          </div>
          
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <Input
                  type="text"
                  name="name"
                  placeholder="Votre nom"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <Input
                  type="email"
                  name="email"
                  placeholder="Votre email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <Textarea
                  name="message"
                  placeholder="Votre message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={5}
                  required
                />
              </div>
              
              <Button type="submit" className="submit-button">
                <Send className="button-icon" />
                Envoyer le Message
              </Button>
            </form>
          </div>
        </div>
      </div>
      
      <footer className="site-footer">
        <div className="container">
          <p>&copy; 2025 Christiane YAO - Tous droits réservés</p>
          <p>Créé avec passion pour la cuisine vegan et durable</p>
        </div>
      </footer>
    </section>
  );
};

export default ContactSection;